<svelte:options tag="w-button" accessors />
<script>
  export let redirectUrl;
  export let title = 'button';
  export let target = '_self';

  const redirectTo = () => {
    window.open(redirectUrl, target);
  };
</script>

<button class="btn btn-search-1" on:click={redirectTo}>{@html title}</button>